import { createTheme } from "@mui/material";

import typography from "./typography";
import palette from "./palette";

const theme = createTheme({
  palette,
  typography
});

export default theme;
